import { userAgent } from 'ua_parser';

export default function(userAgentString) {
  const ua = userAgent(userAgentString);

  return {
    platform: ua.platform,
    browser: ua.browser.name,
    browserVersion: ua.browser.version,
    os: ua.os.name,
    osVersion: ua.os.version,
  };
}



// WEBPACK FOOTER //
// ./src/util/browserDetection.js